import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { PermissionControlService } from '@mirage-projects/cw-commons';
import { Project } from '@mirage-projects/cw-models';

import { ShowRelatedProjectsService } from './show-related-projects.service';

/**
 * It shows a popup with a list of the related projects of a specific object(layer or job site)
 */
@Component({
    selector: 'cw-show-related-projects',
    templateUrl: './show-related-projects.component.html',
    styleUrls: ['./show-related-projects.component.scss'],
    standalone: false,
})
export class ShowRelatedProjectsComponent implements OnInit, OnDestroy {
    /** Custom description to show in the popup */
    @Input() description!: string;

    projectList!: Project[];
    errorMsg?: string;
    isLoading = false;

    private onDestroy$ = new Subject<void>();
    constructor(
        private showRelatedProjectService: ShowRelatedProjectsService,
        private permissionControlService: PermissionControlService
    ) {}

    ngOnInit(): void {
        this.updateListListener();
        this.errorMessageListener();
        this.isLoadingListener();
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }

    onOpenViewerClicked(project: Project): void {
        this.showRelatedProjectService.openProjectViewer(project);
    }

    onDettachObjectClicked(project: Project): void {
        this.showRelatedProjectService.dettachObjectFromProject(project.id);
    }

    hasPermissionsToUpdateProject(project: Project): boolean {
        return this.permissionControlService.canWriteByPermissions(project);
    }

    private errorMessageListener(): void {
        this.showRelatedProjectService.errorMessage$.pipe(takeUntil(this.onDestroy$)).subscribe((error) => {
            this.errorMsg = error;
        });
    }

    private updateListListener(): void {
        this.showRelatedProjectService.projectList$.pipe(takeUntil(this.onDestroy$)).subscribe((projects) => {
            this.projectList = projects;
        });
    }

    private isLoadingListener(): void {
        this.showRelatedProjectService.isLoading$.pipe(takeUntil(this.onDestroy$)).subscribe((isLoading) => (this.isLoading = isLoading));
    }
}
